import React from "react";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const NextArrow = ({ onClick }) => (
  <div className="slider-arrow next" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slider-arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const AITPRJ03 = () => {

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="package-detail">

      {/* HERO */}
      <div
        className="package-hero-banner"
        style={{
          backgroundImage: "url('/Images/tour/050d7210-ed1_big.jpg')",
        }}
      >
        <Container>
          <div className="hero-content">
            <h1>Udaipur – Mount Abu – Jodhpur Tour (AITP / RJ-03)</h1>

            <p className="hero-subtitle">
              4 Nights / 5 Days • Udaipur – Mount Abu – Jodhpur
            </p>

            <div className="hero-price">
              Starting From <span>₹17,900*</span> / Per Person
            </div>
          </div>
        </Container>
      </div>

      <Container className="package-container">

        {/* SLIDER + ENQUIRY */}
        <Row className="mb-4">

          <Col lg={8}>
            <div className="package-slider">
              <Slider {...sliderSettings}>
                <img src="/Images/tour/5c3239f2-75e_big.jpg" alt="" />
                <img src="/Images/tour/a361c1f2-68f_big.jpg" alt="" />
                <img src="/Images/tour/1d0adf1b-074_big.jpg" alt="" />
              </Slider>
            </div>
          </Col>

          <Col lg={4}>
            <div className="enquiry-sidebar">
              <h2>₹17,900*</h2>
              <p>Per Person</p>

              <Button variant="danger" className="mb-3">
                Book Now
              </Button>

              <form>
                <input type="text" placeholder="Your Name" />
                <input type="text" placeholder="Mobile Number" />
                <input type="date" />
                <input type="number" placeholder="Persons" />
                <textarea placeholder="Message"></textarea>

                <Button variant="dark">Send Enquiry</Button>
              </form>
            </div>
          </Col>

        </Row>

        {/* MAIN CONTENT */}
        <Row>
          <Col lg={8}>

            <div className="package-header">
              <h1>Rajasthan Heritage Tour</h1>
              <p>Udaipur • Mount Abu • Jodhpur | 4 Nights / 5 Days</p>
            </div>

            {/* Highlights */}
            <div className="content-box highlight-box">
              <h3>Tour Highlights</h3>

              <Row>
                <Col md={6}>✔ City Palace Udaipur</Col>
                <Col md={6}>✔ Lake Pichola Cruise</Col>
                <Col md={6}>✔ Jagdish Temple</Col>
                <Col md={6}>✔ Dilwara Jain Temples</Col>
                <Col md={6}>✔ Nakki Lake Mount Abu</Col>
                <Col md={6}>✔ Mehrangarh Fort Jodhpur</Col>
              </Row>
            </div>

            {/* Overview */}
            <div className="content-box">
              <h3>Overview</h3>
              <p>
                Explore the royal charm of Rajasthan covering the romantic
                lakes of Udaipur, peaceful hill station Mount Abu and the
                majestic blue city Jodhpur. Experience heritage palaces,
                temples, forts and cultural traditions during this memorable
                Rajasthan journey.
              </p>
            </div>

            {/* ITINERARY */}
            <div className="content-box">
              <h3>Day Wise Itinerary</h3>

              <Accordion defaultActiveKey="0">

                <Accordion.Item eventKey="0">
                  <Accordion.Header>Day 1 – Arrival Udaipur</Accordion.Header>
                  <Accordion.Body>
                    Arrival pickup and hotel check-in. Evening at leisure.
                    Explore the beautiful City of Lakes. Overnight stay
                    in Udaipur.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>Day 2 – Udaipur Sightseeing</Accordion.Header>
                  <Accordion.Body>
                    Visit City Palace, Zenana Mahal, Durbar Hall,
                    Jagdish Temple and Sahelion-ki-Bari. Optional boat
                    cruise on Lake Pichola (not included). Overnight stay.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Day 3 – Udaipur to Mount Abu (190 KM)
                  </Accordion.Header>
                  <Accordion.Body>
                    Drive to Mount Abu. Visit Dilwara Jain Temples,
                    Achalgarh Fort and Nakki Lake. Overnight stay
                    at Mount Abu.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    Day 4 – Mount Abu to Jodhpur (270 KM)
                  </Accordion.Header>
                  <Accordion.Body>
                    Drive to Jodhpur. Visit Mehrangarh Fort,
                    Jaswant Thada and Umaid Public Gardens.
                    Overnight stay in Jodhpur.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    Day 5 – Jodhpur to Udaipur Departure
                  </Accordion.Header>
                  <Accordion.Body>
                    After breakfast drive back to Udaipur.
                    Drop at airport/railway station.
                  </Accordion.Body>
                </Accordion.Item>

              </Accordion>
            </div>

            {/* INCLUSION / EXCLUSION */}
            <div className="content-box">
              <Row>
                <Col md={6}>
                  <h4>Inclusions</h4>
                  <ul>
                    <li>Hotel Accommodation</li>
                    <li>Daily Breakfast</li>
                    <li>Private Vehicle</li>
                    <li>Sightseeing Tours</li>
                  </ul>
                </Col>

                <Col md={6}>
                  <h4>Exclusions</h4>
                  <ul>
                    <li>Monument Entry Fees</li>
                    <li>Boat Ride Charges</li>
                    <li>Personal Expenses</li>
                    <li>Travel Insurance</li>
                  </ul>
                </Col>
              </Row>
            </div>

            {/* HOTEL DETAILS */}
            <div className="content-box">
              <h3>Hotel Details</h3>
              <p>
                Comfortable deluxe category hotels in Udaipur,
                Mount Abu and Jodhpur with modern amenities.
              </p>
            </div>

            {/* RATE */}
            <div className="content-box">
              <h3>Rate & Summary</h3>
              <p>
                Starting price ₹17,900 per person on twin sharing basis.
                Rates may vary as per season and availability.
              </p>
            </div>

            {/* TERMS */}
            <div className="content-box">
              <h3>Terms & Conditions</h3>
              <ul>
                <li>Booking subject to availability.</li>
                <li>Advance payment required.</li>
                <li>Cancellation policy applicable.</li>
              </ul>
            </div>

            {/* TRAVEL TIPS */}
            <div className="content-box">
              <h3>Travel Tips</h3>
              <ul>
                <li>Carry valid ID proof.</li>
                <li>Best season: October – March.</li>
                <li>Comfortable walking shoes recommended.</li>
                <li>Stay hydrated during travel.</li>
              </ul>
            </div>

          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default AITPRJ03;